// extracted by mini-css-extract-plugin
export var closed = "_7m-1";
export var resizer = "_7m-0";